import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  effect,
  EventEmitter,
  inject,
  input,
  Output
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import {
  NzDrawerComponent,
  NzDrawerContentDirective
} from 'ng-zorro-antd/drawer';
import { NzSelectComponent } from 'ng-zorro-antd/select';

import { IImportSource, SourceTypes } from '../../index';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-import-excel-drawer',
  standalone: true,
  imports: [
    NzDrawerComponent,
    NzButtonComponent,
    NzDividerComponent,
    NzDrawerContentDirective,
    NzSelectComponent,
    NzWaveDirective,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './import-excel-drawer.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportExcelDrawerComponent {
  #destroyRef = inject(DestroyRef);
  showImportDrawer = input<boolean>(false);
  importSources = input.required<IImportSource[]>();
  country = input<string>('');
  headerRowNo = input<any>(null);
  title = input.required<any>();
  sampleDownloadUrl = input<string>('');
  selectedImportSource = input<SourceTypes | null>(null);

  importSourcesOptions = computed(() => {
    return [{ label: '—None—', value: null }, ...this.importSources()];
  });
  selectedSourceControl = new FormControl();

  constructor() {
    effect(() => {
      if (this.selectedImportSource()) {
        this.selectedSourceControl.setValue(this.selectedImportSource());
      }
    });

    this.selectedSourceControl.valueChanges
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(res => {
        this.requestChangeImportSource.emit(res);
      });
  }

  @Output() readonly requestImportData = new EventEmitter();
  @Output() readonly requestChangeImportSource = new EventEmitter();
  @Output() readonly requestCloseImportDrawer = new EventEmitter();
}
